import type { DictionaryCube } from './types'

export const dictionaryCube: DictionaryCube = {
  name: 'Имя съемки',
  domain: 'Домен',
  shapeIlines: 'Кол-во Ilines',
  shapeXlines: 'Кол-во Xlines',
  shapeHlines: 'Кол-во Hlines',
  rangeIlinesMin: 'Min Iline',
  rangeXlinesMin: 'Min Xline',
  rangeHlinesMin: 'Min Hline',
  rangeIlinesMax: 'Max Iline',
  rangeXlinesMax: 'Max Xline',
  rangeHlinesMax: 'Max Hline',
  amplitudeMin: 'Амплитуда min',
  amplitudeMax: 'Амплитуда max',
  stepILines: 'Шаг ILine',
  stepXLines: 'Шаг XLine',
  stepHLines: 'Шаг HLine',
  shift: 'Время delayRecordingTime',
}
